export enum AtiraLinkPlanBrand {
  // Our brand is visible
  PLAN_0 = 'off',
  // Our brand is visible but can be hidden
  PLAN_1 = 'unlimited',
  PLAN_2 = 'unlimited',
}
